import { useLocation as useRouterLocation, useSearchParams } from 'react-router-dom';

export const useLocation = () => {
  const location = useRouterLocation();
  const [searchParameters, setSearchParameters] = useSearchParams();

  return { location, searchParameters, setSearchParameters };
};
